module.exports = __webpack_public_path__ + "static/media/work-with-us_analysis.01cf2cd5.png";